/**
 * administration operations
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


import {
    REST_CALL_EXPORT_DATABASE,
    REST_CALL_IMPORT_DATABASE,
    REST_CALL_IMPORT_UPLOADS,
    REST_CALL_IMPORT_USERCONTENT,
    REST_SERVER_BASE_URL
} from "../config";
import {showError} from "./message";
import saveAs from 'file-saver';
import {getDateForFileName} from '../utils';
import {openPageAction} from "../redux/view/actions";
import {CONTROL_PAGE, ADMIN_PAGE} from "../redux/view/consts";
import {showMessageAction} from "../redux/message/actions";
import {pushStateAction} from "../redux/navigation/actions";


export function exportDatabase(includeHistory, includePasswords) {

    return async (dispatch, getState) => {

        const {authorization} = getState();

        if (authorization.userPrivileges.exportDatabase) try {
            const response = await fetch(
                REST_SERVER_BASE_URL + REST_CALL_EXPORT_DATABASE.path.replace(
                    "<history>", includeHistory ? "yes" : "no"
                ).replace(
                    "<passwords>", includePasswords ? "yes" : "no"
                ),
                {
                    method: REST_CALL_EXPORT_DATABASE.method,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + authorization.accessToken
                    }
                }
            );

            const blob = await response.blob();
            saveAs(blob, "database_dump_" + getDateForFileName(new Date()) + ".json");
        }
        catch (error) {
            showError(error)(dispatch);
        }
    }
}

export function importDatabase(file, onFinish) {

    return async (dispatch, getState) => {

        const {authorization} = getState();

        let formData = new FormData();
        formData.append("file", file);

        if (authorization.userPrivileges.importDatabase) try {

            const response = await fetch(
                REST_SERVER_BASE_URL + REST_CALL_IMPORT_DATABASE.path,
                {
                    method: REST_CALL_IMPORT_DATABASE.method,
                    body: formData,
                    headers: {
                        "Authorization": "Bearer " + authorization.accessToken
                    }
                }
            );

            console.log("uploaded database file with server response", response);
            dispatch(showMessageAction("uploaded sucessfully"));
            onFinish && onFinish(null);
        }
        catch (error) {
            showError(error)(dispatch);
            onFinish && onFinish(error.message || error.msg);
        }
    }
}

export function importUploads(file, onFinish) {

    return async (dispatch, getState) => {

        const {authorization} = getState();

        let formData = new FormData();
        formData.append("file", file);

        if (authorization.userPrivileges.importDatabase) try {

            const response = await fetch(
                REST_SERVER_BASE_URL + REST_CALL_IMPORT_UPLOADS.path,
                {
                    method: REST_CALL_IMPORT_UPLOADS.method,
                    body: formData,
                    headers: {
                        "Authorization": "Bearer " + authorization.accessToken
                    }
                }
            );

            console.log("uploaded archive file with server response", response);
            dispatch(showMessageAction("uploaded sucessfully"));
            onFinish && onFinish(null);
        }
        catch (error) {
            showError(error)(dispatch);
            onFinish && onFinish(error.message || error.msg);
        }
    }
}

export function importUserContent(file, onFinish) {

    return async (dispatch, getState) => {

        const {authorization} = getState();

        let formData = new FormData();
        formData.append("file", file);

        if (authorization.userPrivileges.importDatabase) try {

            const response = await fetch(
                REST_SERVER_BASE_URL + REST_CALL_IMPORT_USERCONTENT.path,
                {
                    method: REST_CALL_IMPORT_USERCONTENT.method,
                    body: formData,
                    headers: {
                        "Authorization": "Bearer " + authorization.accessToken
                    }
                }
            );

            console.log("uploaded archive file with server response", response);
            dispatch(showMessageAction("uploaded sucessfully"));
            onFinish && onFinish(null);
        }
        catch (error) {
            showError(error)(dispatch);
            onFinish && onFinish(error.message || error.msg);
        }
    }
}

export function openControlPage() {

    return async (dispatch, getState) => {

        const {authorization} = getState();

        if (authorization.userPrivileges.openControlDashboard) {

            // push new state
            dispatch(pushStateAction("control dashboard", "?page=control"));
            dispatch(openPageAction(CONTROL_PAGE));
        }
    }
}

export function openAdminPage() {

    return async (dispatch, getState) => {

        const privileges = getState().authorization.userPrivileges

        if (privileges.openAdminDashboard || privileges.exportDatabase) {

            // push new state
            dispatch(pushStateAction("admin dashboard", "?page=admin"));
            dispatch(openPageAction(ADMIN_PAGE));
        }
    }
}